import config from 'config';
import axiosInstance from '../API/createAxisInstance';
import { CancelToken } from 'axios';

export default class API {
  static baseUrl = config.fiasApiBaseUrl;

  /**
   * @param {'GET'|'PUT'|'POST'|'DELETE'} method
   * @param {string} url
   * @param {object} [params]
   * @param {object} [data]
   * @param {object} [headers]
   * @param {function} [mapper]
   * @returns {AxiosPromise}
   */
  static request({ method, url, params, data, headers, mapper = (data) => data }) {
    let cancel;
    const request = axiosInstance({
      method,
      url: `${API.baseUrl}${url}`,
      params,
      data,
      headers,
      cancelToken: new CancelToken(function executor(c) {
        // An executor function receives a cancel function as a parameter
        cancel = c;
      }),
    }).then((response) => {
      if (response.isOk) {
        return { ...response, data: mapper(response.data) };
      } else {
        return response;
      }
    });

    return { request, cancel };
  }
}

export function findRegions(region) {
  return API.request({
    method: 'POST',
    url: `/addresses/findRegion`,
    headers: {
      'Content-Type': 'application/json;charset=UTF-8',
    },
    params: {
      region,
    },
  });
}

export function findDistrict(district, args = {}) {
  return API.request({
    method: 'POST',
    url: `/addresses/findDistrict`,
    headers: {
      'Content-Type': 'application/json;charset=UTF-8',
    },
    params: {
      district,
      ...args,
    },
  });
}

export function findCity(city, args = {}) {
  return API.request({
    method: 'POST',
    url: `/addresses/findCity`,
    headers: {
      'Content-Type': 'application/json;charset=UTF-8',
    },
    params: {
      city,
      ...args,
    },
  });
}

export function findLocality(locality, args = {}) {
  return API.request({
    method: 'POST',
    url: `/addresses/findLocality`,
    headers: {
      'Content-Type': 'application/json;charset=UTF-8',
    },
    params: {
      locality,
      ...args,
    },
  });
}

export function findStreet(street, args = {}) {
  return API.request({
    method: 'POST',
    url: `/addresses/findStreet`,
    headers: {
      'Content-Type': 'application/json;charset=UTF-8',
    },
    params: {
      street,
      ...args,
    },
  });
}

export function findHouseNumber(houseNumber, args = {}) {
  return API.request({
    method: 'POST',
    url: `/houses/findHouseNumber`,
    headers: {
      'Content-Type': 'application/json;charset=UTF-8',
    },
    params: {
      houseNumber,
      ...args,
    },
  });
}

export function findBuildingNumber(buildingNumber, args = {}) {
  return API.request({
    method: 'POST',
    url: `/houses/findBuildingNumber`,
    headers: {
      'Content-Type': 'application/json;charset=UTF-8',
    },
    params: {
      buildingNumber,
      ...args,
    },
  });
}

export function findStructNumber(structNumber, args = {}) {
  return API.request({
    method: 'POST',
    url: `/houses/findStructNumber`,
    headers: {
      'Content-Type': 'application/json;charset=UTF-8',
    },
    params: {
      structNumber,
      ...args,
    },
  });
}

export function findTaxAuthority(cadNum, args = {}) {
  return API.request({
    method: 'POST',
    url: `/houses/findIfnsFl`,
    headers: {
      'Content-Type': 'application/json;charset=UTF-8',
    },
    params: {
      cadNum,
      ...args,
    },
  });
}
